/* Personnaliseur Kimenya — moteur générique (aucune app).
   Lit une config JSON (calques dans l'ordre de dessin + champs du formulaire), dessine l'aperçu en direct sur un canvas
   et pose les choix dans la commande (propriétés de ligne + « _perso » pour régénérer le fichier d'impression). */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  var cache = {};
  function img(src) {
    if (!src) return Promise.resolve(null);
    if (!cache[src]) cache[src] = new Promise(function (ok) {
      var i = new Image(); i.onload = function () { ok(i); }; i.onerror = function () { ok(null); };
      i.src = src + (src.indexOf('quote-') > 0 ? '?width=1400' : '');
    });
    return cache[src];
  }

  function Perso(root) {
    this.root = root; this.sel = {}; this.tab = {};
    var self = this;
    fetch(root.dataset.config).then(function (r) { return r.json(); }).then(function (cfg) {
      self.cfg = cfg;
      var ff = new FontFace('PersoNom', 'url(' + root.dataset.font + ')');
      ff.load().then(function (f) { document.fonts.add(f); self.draw(); }).catch(function () {});
      cfg.fields.forEach(function (f) {
        if (f.kind === 'choix') self.sel[f.id] = f.opts[0].v;
        else if (f.kind === 'text') self.sel[f.id] = '';
        else { self.sel[f.id] = f.g[0].o[0].v; self.tab[f.id] = 0; if (f.g[0].id) self.sel[f.id + '#g'] = f.g[0].id; }
      });
      self.form(); self.draw();
    });
  }

  Perso.prototype.on = function (dep, n) {
    if (!dep) return true;
    if ((n || 0) > 8) return false;
    var self = this, s = this.sel;
    if (!this.deps) { this.deps = {}; this.cfg.layers.concat(this.cfg.fields).forEach(function (x) { if (x.dep) self.deps[x.id] = x.dep; }); }
    var ok = dep.d.map(function (d) {      /* l'élément dont on dépend doit lui-même être visible */
      return (d[1].indexOf(s[d[0]]) >= 0 || d[1].indexOf(s[d[0] + '#g']) >= 0) && self.on(self.deps[d[0]], (n || 0) + 1);
    });
    return dep.all ? ok.every(Boolean) : ok.some(Boolean);
  };

  Perso.prototype.valueName = function (f) {
    var v = this.sel[f.id];
    if (f.kind === 'text') return v;
    if (f.kind === 'choix') return (f.opts.find(function (o) { return o.v === v; }) || {}).n;
    for (var gi = 0; gi < f.g.length; gi++) {
      var o = f.g[gi].o.find(function (x) { return x.v === v; });
      if (o) return (f.g.length > 1 && !o.x ? f.g[gi].n + ' · ' : '') + (/^\d+$/.test(o.n) ? 'n° ' + o.n : o.n);
    }
    return '';
  };

  Perso.prototype.form = function () {
    var self = this, cfg = this.cfg, box = this.root.querySelector('[data-perso-champs]');
    box.innerHTML = '';
    cfg.fields.forEach(function (f) {
      if (!self.on(f.dep)) return;
      var w = document.createElement('div'); w.className = 'pz-f';
      var lab = document.createElement('div'); lab.className = 'pz-l';
      lab.innerHTML = f.label + (f.kind !== 'text' ? ' : <span>' + (self.valueName(f) || '') + '</span>' : '');
      w.appendChild(lab);
      if (f.kind === 'choix') {
        var r = document.createElement('div'); r.className = 'pz-ch';
        f.opts.forEach(function (o) {
          var b = document.createElement('button'); b.type = 'button'; b.textContent = o.n; if (self.sel[f.id] === o.v) b.className = 'on';
          b.onclick = function () { self.sel[f.id] = o.v; self.form(); self.draw(); }; r.appendChild(b);
        });
        w.appendChild(r);
      } else if (f.kind === 'liste') {
        var s = document.createElement('select'); s.className = 'pz-s';
        f.g[0].o.forEach(function (o) { var op = document.createElement('option'); op.value = o.v; op.textContent = o.n; if (self.sel[f.id] === o.v) op.selected = true; s.appendChild(op); });
        s.onchange = function () { self.sel[f.id] = s.value; self.form(); self.draw(); };
        w.appendChild(s);
      } else if (f.kind === 'text') {
        var i = document.createElement('input'); i.type = 'text'; i.className = 'pz-t'; i.maxLength = f.max; i.placeholder = f.ph; i.value = self.sel[f.id];
        var c = document.createElement('span'); c.className = 'pz-c'; c.textContent = i.value.length + '/' + f.max;
        i.oninput = function () { self.sel[f.id] = i.value; c.textContent = i.value.length + '/' + f.max; self.sync(); self.draw(); };
        var wr = document.createElement('div'); wr.className = 'pz-tw'; wr.appendChild(i); wr.appendChild(c); w.appendChild(wr);
        var h = document.createElement('div'); h.className = 'pz-h'; h.textContent = f.hint; w.appendChild(h);
      } else {
        if (f.g.length > 1) {
          var tabs = document.createElement('div'); tabs.className = 'pz-tabs';
          f.g.forEach(function (g, gi) {
            var b = document.createElement('button'); b.type = 'button'; b.textContent = g.n; if (self.tab[f.id] === gi) b.className = 'on';
            b.onclick = function () { self.tab[f.id] = gi; self.sel[f.id] = g.o[0].v; if (g.id) self.sel[f.id + '#g'] = g.id; self.form(); self.draw(); }; tabs.appendChild(b);
          });
          w.appendChild(tabs);
        }
        var g = f.g[self.tab[f.id] || 0], grid = document.createElement('div'); grid.className = 'pz-g' + (f.swatch ? ' pz-sw' : '') + (f.court ? ' pz-fl' : '');
        g.o.forEach(function (o, k) {
          var b = document.createElement('button'); b.type = 'button'; b.title = o.n; b.setAttribute('aria-label', o.n);
          if (self.sel[f.id] === o.v) b.className = 'on';
          var t = document.createElement('i');
          if (o.x) { t.className = 'pz-x'; t.textContent = 'Sans'; b.appendChild(t); b.onclick = function () { self.sel[f.id] = o.v; self.form(); self.draw(); }; grid.appendChild(b); return; }
          t.style.backgroundImage = 'url(' + g.sp + ')';
          t.style.backgroundSize = (g.c * 100) + '% ' + (g.r * 100) + '%';
          t.style.backgroundPosition = (g.c > 1 ? (o.i % g.c) / (g.c - 1) * 100 : 0) + '% ' + (g.r > 1 ? Math.floor(o.i / g.c) / (g.r - 1) * 100 : 0) + '%';
          b.appendChild(t);
          if (f.court) { var m = document.createElement('b'); m.textContent = f.court[k]; b.appendChild(m); }
          b.onclick = function () { self.sel[f.id] = o.v; self.form(); self.draw(); };
          grid.appendChild(b);
        });
        w.appendChild(grid);
      }
      box.appendChild(w);
    });
    this.sync();
  };

  /* Choix -> formulaire d'achat : propriétés lisibles + « _perso » complet */
  Perso.prototype.sync = function () {
    var self = this, forms = document.querySelectorAll('form[action*="/cart/add"]');
    var props = {}, raw = {};
    this.cfg.fields.forEach(function (f) {
      if (!self.on(f.dep)) return;
      raw[f.id] = self.sel[f.id];
      var v = self.valueName(f);
      if (f.kind === 'text') { if (v && v.trim()) props[f.label] = v.trim(); }
      else if (v) props[f.label] = v;
    });
    props._perso = JSON.stringify(raw);
    forms.forEach(function (form) {
      form.querySelectorAll('input[data-pz]').forEach(function (x) { x.remove(); });
      Object.keys(props).forEach(function (k) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = props[k]; i.setAttribute('data-pz', '');
        form.appendChild(i);
      });
    });
  };

  Perso.prototype.draw = function () {
    var self = this; clearTimeout(this.t);
    this.t = setTimeout(function () { self.paint(); }, 40);
  };

  Perso.prototype.paint = function () {
    var self = this, cfg = this.cfg, S = cfg.s || 0.42, n = ++this.n || (this.n = 1);
    var list = cfg.layers.filter(function (l) { return self.on(l.dep); });
    Promise.all(list.map(function (l) {
      if (l.t === 'text') return null;
      var src = l.t === 'static-photo' ? l.src : (self.sel[l.id] || l.def);
      return img(src);
    })).then(function (ims) {
      if (n !== self.n) return;
      var c = document.createElement('canvas'); c.width = Math.round(cfg.w * S); c.height = Math.round(cfg.h * S);
      var x = c.getContext('2d');
      list.forEach(function (l, k) {
        var b = l.b.map(function (v) { return v * S; });
        x.save();
        if (l.t === 'text') {
          var t = (self.sel[l.f || l.id] || ''); if (l.upper) t = t.toUpperCase();
          if (t.trim()) {
            var fs = l.size * S; x.font = '700 ' + fs + 'px PersoNom, serif';
            while (x.measureText(t).width > b[2] && fs > 4) { fs -= 0.5; x.font = '700 ' + fs + 'px PersoNom, serif'; }
            x.translate(b[0], b[1]); x.rotate(l.r * Math.PI / 180); x.fillStyle = l.color; x.textAlign = l.al === 'left' ? 'left' : 'center'; x.textBaseline = 'middle';
            x.fillText(t, 0, 0);
          }
        } else if (ims[k]) {
          x.translate(b[0] + b[2] / 2, b[1] + b[3] / 2); x.rotate(l.r * Math.PI / 180); x.drawImage(ims[k], -b[2] / 2, -b[3] / 2, b[2], b[3]);
        }
        x.restore();
      });
      var out = self.root.querySelector('canvas[data-perso-apercu]'), o = out.getContext('2d');
      if (!cfg.soles) { out.width = c.width; out.height = c.height; o.clearRect(0, 0, c.width, c.height); o.drawImage(c, 0, 0); return; }
      var s0 = cfg.soles[0], sw = (s0[2] - s0[0]) * S, shh = (s0[3] - s0[1]) * S, gap = sw * 0.12;
      out.width = Math.round(sw * 2 + gap); out.height = Math.round(shh);
      o.clearRect(0, 0, out.width, out.height);
      cfg.soles.forEach(function (s, k) {
        o.save(); o.translate(k * (sw + gap) + sw / 2, shh / 2); o.rotate(Math.PI);
        o.beginPath(); var rr = sw * 0.42;
        if (o.roundRect) o.roundRect(-sw / 2, -shh / 2, sw, shh, rr); else o.rect(-sw / 2, -shh / 2, sw, shh);
        o.clip();
        o.drawImage(c, s[0] * S, s[1] * S, sw, shh, -sw / 2, -shh / 2, sw, shh);
        o.restore();
      });
    });
  };

  ready(function () { document.querySelectorAll('[data-perso]').forEach(function (r) { if (!r.dataset.ok) { r.dataset.ok = 1; new Perso(r); } }); });
})();
